import { formatName, type ScheduleOverrideWithRelations } from '@snootsvet/shared'

import { Button } from '@/frontend/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/frontend/components/ui/dialog'
import { useDeleteScheduleOverride } from '@/frontend/features/schedules/use-schedule-override-mutations'

interface Props {
  /** The shift to delete, or null when the dialog is closed. */
  override: ScheduleOverrideWithRelations | null
  onClose: () => void
}

/** Confirms deleting a one-off shift; owns the delete mutation. */
export function DeleteShiftDialog({ override, onClose }: Props) {
  const { mutate: remove, isPending } = useDeleteScheduleOverride()

  return (
    <Dialog open={override !== null} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete shift?</DialogTitle>
        </DialogHeader>
        <p className="text-muted-foreground">
          {override && (
            <>
              The shift for{' '}
              <span className="font-medium text-foreground">{formatName(override.staff)}</span> on{' '}
              <span className="font-medium text-foreground">{override.date}</span> will be deleted.
              This cannot be undone.
            </>
          )}
        </p>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            disabled={isPending}
            onClick={() => override && remove(override.id, { onSuccess: onClose })}
          >
            {isPending ? 'Deleting...' : 'Delete'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
